export function transformResponseToFormState(_a) {
    var services_ssh_password_auth = _a.services_ssh_password_auth, services_ssh_root_login = _a.services_ssh_root_login;
    var transformedData = {
        sshPasswordAuth: services_ssh_password_auth.enabled,
        sshRootLogin: services_ssh_root_login.enabled,
    };
    return transformedData;
}
